import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import axios from "axios";
import {
  Link,
  Container,
  Box,
  CssBaseline,
  TextField,
  Grid,
  Button,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";

const SignIn = () => {
  const [showSnack, setShowSnack] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("error");
  const [snackMessage, setSnackMessage] = useState<any>();
  const [done, setDone] = useState(false);
  const [email, setEmail] = useState<string>();
  const handlReset = (e: any) => {
    e.preventDefault();
    const email = e.target.email.value;
    axios
      .post(
        process.env.REACT_APP_READABLE_BACKEND_URL + "reset-password/",
        {
          email: email,
          url: process.env.REACT_APP_READABLE_URL,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setDone(true);
        setEmail(email);
      })
      .catch(() => {
        setSnackMessage("未找到该邮箱地址");
        setSnackSeverity("error");
        setShowSnack(true);
      });
  };
  const handleResubimt = () => {
    axios
      .post(
        process.env.REACT_APP_READABLE_BACKEND_URL + "reset-password/",
        {
          email: email,
          url: process.env.REACT_APP_READABLE_URL,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setSnackMessage("已重新发送确认邮件。");
        setSnackSeverity("info");
        setShowSnack(true);
      })
      .catch(() => {
        setSnackMessage("发生错误");
        setSnackSeverity("error");
        setShowSnack(true);
      });
  };
  if (done) {
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Typography
          component="h2"
          variant="body1"
          color="text.primary"
          align="center"
          sx={{ mt: 4 }}
        >
          确认邮件已发送至 {email}。
        </Typography>
        <Typography
          component="h2"
          variant="body1"
          color="text.primary"
          align="center"
          sx={{ mb: 2 }}
        >
          请点击邮件中的链接重置密码。
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
          }}
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleResubimt}
          >
            重新发送
          </Button>
        </Box>
        <Snackbar
          open={showSnack}
          autoHideDuration={6000}
          onClose={() => setShowSnack(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setShowSnack(false)}
            // @ts-ignore
            severity={snackSeverity}
            sx={{ width: "100%" }}
          >
            {snackMessage}
          </Alert>
        </Snackbar>
      </Container>
    );
  }
  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          fontWeight="fontWeightBold"
        >
          重置密码
        </Typography>
        <Box
          component="form"
          noValidate
          onSubmit={handlReset}
          sx={{
            mt: 3,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="email"
            label="电子邮件地址"
            name="email"
            autoComplete="email"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            发送
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link variant="body2" to="/login" component={RouterLink}>
                登录
              </Link>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link variant="body2" to="/pricing" component={RouterLink}>
                会员注册
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Snackbar
        open={showSnack}
        autoHideDuration={6000}
        onClose={() => setShowSnack(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShowSnack(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default SignIn;
